export const ALLOWED_PAGE_SIZES = [6, 12, 18, 24, 30] as const;
export const DEFAULT_PAGE_SIZE = 6;
export const DOUBLE_CLICK_THRESHOLD_MS = 300;

export const ABSENCE_STATUS = {
  REJECTED: -1,
  UNCONFIRMED: 0,
  MANAGER_CONFIRMED: 1,
  HR_CONFIRMED: 2,
  CANCELLED: 3,
} as const;

export const TRANSFER_STATUS = {
  FROM_OPTIMA: 0,
  FROM_HR: 1,
} as const;

export const HEALTH_ABSENCE_TYPE = 8;
